import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Permissions } from '@dc-core/dc-backend/dc-enums';
import { of } from 'rxjs';

import { UserService } from '../../user/services/user.service';

export const permissionToGuard: CanActivateFn = (route) => {
    const userService: UserService = inject(UserService);

    const permission: Permissions = route.data.permission;

    return of(userService.hasPermissionTo(permission));
};
